import { url } from '#packages/util';
import { FORCE_SECTION_MIGRATION_ORIGIN_PARAM } from './constants';

export const getForceMigrationOriginQueryParam = () => {
  return url.parseUrl(window.location.href).query[
    FORCE_SECTION_MIGRATION_ORIGIN_PARAM
  ];
};
